import { QueryReturnValue } from '@reduxjs/toolkit/dist/query/baseQueryTypes'
import { MaybePromise } from '@reduxjs/toolkit/dist/query/tsHelpers'
import { Method } from 'axios'
import { User } from 'firebase/auth'

import { unregisteredUserBaseQuery } from '../unregistered-user/query'

interface CompanyPrePaywallBaseQueryProps {
    baseQuery: (arg: {
        url: string
        method: Method | undefined
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        data?: any
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        params?: any
    }) => MaybePromise<QueryReturnValue<unknown, unknown, object>>
    user?: User | null
}

export const companyPrePaywallBaseQuery = ({ baseQuery, user = null }: CompanyPrePaywallBaseQueryProps) => {
    // Check first if user is authenticated (signed up user)
    if (user) {
        return baseQuery
    }

    // If not, replace the headers with the temporary Authorization header (ghost user)
    return unregisteredUserBaseQuery
}
